<template>

  <div class="demo-spin-article">

    <Row type="flex" :gutter="24" class="mb-30">
      <Col :xs="24" :sm='24' :md="24" :lg="8" :xl="6" class="mb-10">
        <Input
          class="search-input-100 w-lg-100"
          placeholder="Введите номер счета"
          v-model="searchString">
          <Icon type="ios-search" slot="suffix"/>
        </Input>
      </Col>

      <Col :xs="24" :sm='12' :md="12" :lg="6" :xl="6" :xxl="5" class="mb-10">
        <Select v-model="statusFilter" label="Выбрать статус" class="br-18">
          <Option value="ISSUED">Выставлен</Option>
          <Option value="PARTIALLY">Частично оплачен</Option>
          <Option value="PAID">Оплачен</Option>
          <Option value="CANCELED">Аннулирован</Option>
          <Option value="PARTIALLY,PAID,CANCELED,ISSUED">Все статусы</Option>
        </Select>
      </Col>

      <Col :xs="24" :sm='12' :md="12" :lg="6" :xl="6" :xxl="5" class="mb-10">
        <DatePicker
          class="w-100"
          style="width: 100%"
          v-model="filterOrderDate"
          @on-change="selectFilterDate"
          format="yyyy-MM-dd"
          type="daterange"
          :start-date="currentDate"
          placeholder="Дата документа"
        ></DatePicker
        >
      </Col>

    </Row>


    <Row type="flex" class="mb-30" v-if="showClearButton">
      <Col>
        <Button
          @click="clearFilter"
          type="error"
        >Сбросить фильтр</Button>
      </Col>

    </Row>

    <Table
      class="desktop_table"
      :loading="loading"
      :columns="columns"
      :data="data"
      @on-sort-change="changeSorting"
      @on-selection-change="onSelectChange"
    ></Table>

    <!-- DATA MOBILE TABLE -->
    <div class="mobile-table">

      <div v-for="item in data" class="card-container">
        <div>
          <h2>Номер счета: {{item.billId}}</h2>
          <p>Дата выставления счета: {{formatDateTime(item.creationTime)}}</p>
          <p>Дата и время оплаты: {{formatDateTime(item.paymentTime)}}</p>
          <p>Тип оплаты: {{item.paymentMethod.name}}</p>
          <p>Статус: {{item.status.name}}</p>
          <p>Итого к оплате: {{item.totalAmt}}</p>
          <p>Фактически оплачено: {{item.actuallyPaidAmt}}</p>

          <div>
            <span style="color: #5087DE; font-weight: bold; display: inline-block; padding: 10px 0"
            @click="showReportAction(item.billId)">
              Скачать отчет
            </span>
          </div>
        </div>

      </div>
    </div>

    <!--  PAGINATION -->
    <Page
      :total="totalRecords"
      :page-size="pageSize"
      :page-size-opts="[10, 20, 30]"
      @on-change="changePage"
      @on-page-size-change="changePageSize"
      show-sizer
      :styles="{ marginTop: '30px', float: 'right' }"
    />

  </div>


</template>

<script>
    import {server_addr} from "../../http.js";
    import {formatNumber} from "../../base/base_func.js";
    import {BaseTableData} from "../../base/base_table.js";

    let _app = BaseTableData();
    _app.name = "paymentHistory";
    _app.data = function () {
        return {
            // Base settings
            baseViewUrl: server_addr + "/proxy_/billing/v1/myBills",
            loading: true,
            showClearButton: false,


            // Table settings
            columns: [
                {
                    title: "Номер счета",
                    key: "billId",
                    width: 80,
                },
                {
                    title: "Дата выставления счета",
                    align: 'center',
                    key: "creationTime",
                    render: (h, params) => {
                        return h("span", {}, this.formatDateTime(params.row.creationTime))
                    }
                },
                {
                    title: "Дата и время оплаты",
                    align: 'center',
                    key: "paymentTime",
                    render: (h, params) => {
                        return h("span", {}, this.formatDateTime(params.row.paymentTime))
                    }
                },
                {
                    title: "Тип оплаты",
                    align: 'center',
                    key: "paymentMethod",
                    render: (h, params) => {
                        return h("span", {}, params.row.paymentMethod.name)
                    }
                },
                {
                    title: "Статус",
                    align: 'center',
                    key: "status",
                    render: (h, params) => {
                        return h("span", {}, params.row.status.name)
                    }
                },
                {
                    title: "Итого к оплате",
                    align: 'center',
                    key: "totalAmt",
                },
                {
                    title: "Фактически оплачено",
                    align: 'center',
                    key: "actuallyPaidAmt",
                },
                {
                    title: "Скачать счет",
                    align: 'center',
                    render: (h, params) => {
                        return h(
                            "Button",
                            {
                                props: { type: "primary" },
                                on: {
                                    click: () => {
                                        this.showReportAction(params.row.billId);
                                    }
                                },
                                style: {
                                    border: 'none', color: '#5087DE', textDecoration: 'underline', background: 'none', boxShadow: 'none', fontWeight: 'bold'
                                }
                            },

                            "СКАЧАТЬ"
                        );
                        }
                },
            ],

            data: [],
            lastDraw: 0,
            totalRecords: null,
            currentPage: 1,
            pageSize: 10,
            sorting: "",
            searchString: "",
            statusFilter: '',
            filterOrderDate: [],
            filterTimeFrom: null,
            filterTimeTo: null,

        };
    };

    _app.computed.fetchParams = function () {
        let params = {
            format: "table",
            draw: this.lastDraw,
            offset: this.start,
            limit: this.pageSize,
            // billId: this.searchString,
            status: this.statusFilter,
            creationTimeFrom: this.filterTimeFrom,
            creationTimeTo: this.filterTimeTo

        };

        if (this.searchString) {
          params.billId = this.searchString;
        }

        for (let key in this.filter) {
            if (this.filter[key]) {
                params[key] = this.filter[key];
            }
        }

        return params;
    };

    _app.computed.currentDate = function(){
      let date = new Date();
      date.setMonth(date.getMonth() - 1);
      return date;
    };



    // Загружаем данные для таблицы
    _app.methods.fetchItems = function () {
        this.loading = true;
        this.lastDraw++;
        this.$http
            .get(this.baseViewUrl, {
                params: this.fetchParams
            })
            .then(result => {
                  this.data = result.data.list;
                  this.totalRecords = result.data.totalCount;

            })
            .finally(() => {
                this.loading = false;
            });
    };


    // Очистка полей поиска даты документа (Order date), после чего срабатывает watcher и обновляются данные в таблице
    _app.methods.clearFilterOrderDate = function (date_arr, date_obj) {
        this.filter.order_date__gt = "";
        this.filter.order_date__lt = "";
    };

    // Текстовый поиск
    _app.watch.searchString = function(to, from) {
        this.fetchItems();
        this.currentPage = 1;
        if(this.searchString) {
            this.showClearButton = true
        }
    };

    // Фильтр по статусу
    _app.watch.statusFilter = function(to, from) {
        this.fetchItems();
        this.currentPage = 1;
        if(this.statusFilter) {
            this.showClearButton = true
        }

    };

    //Фильтр по дате
    _app.methods.selectFilterDate = function(to, from) {
        let dateString_0 = this.filterOrderDate[0];
        let dateString_1 = this.filterOrderDate[1];
        let date_0 = new Date(dateString_0);
        let date_1 = new Date(dateString_1);

        this.filterOrderDate[0] = date_0.toLocaleDateString("fr-CA");
        this.filterOrderDate[1] = date_1.toLocaleDateString("fr-CA");

        this.filterTimeFrom = this.filterOrderDate[0];
        this.filterTimeTo = this.filterOrderDate[1];
        this.fetchItems();
        this.showClearButton = true

    };

    // Очистка фильтров
    _app.methods.clearFilter = function (val) {
        this.showClearButton = false;
        // Очистка общих фильтров и посика
        if (this.searchString) {
            this.searchString = "";
        }
        if (this.statusFilter) {
            this.statusFilter = "";
        }
        if (this.selectFilterDate) {
            this.filterTimeFrom = null;
            this.filterTimeTo = null;
            this.filterOrderDate = [];
        }

        this.fetchItems();


    };

    //Формируем счет
    _app.methods.showReportAction = function(id) {
        const url = server_addr + "/proxy_/billing/v1/bills/" + id + "/payment";
        this.$http
        ({
            header: {
                'Content-type': 'application/pdf',
            },
            method: "get",
            url: url,
            responseType: "blob"
        })

            .then(response => {
                this.loading = true;
                const blob = new Blob([response.data], { type:"application/pdf" });
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.style.display = "none";
                a.href = url;
                a.download = `paymentHistory.pdf`;
                document.body.appendChild(a);
                a.click();
                window.URL.revokeObjectURL(url);

            })
            .finally(() => {
                this.loading = false;
            })


    };

    _app.mounted = function () {
        this.fetchItems();
    };

    export default _app;
</script>



<style>
  .search-input-100 {
    width: 100%;
  }
  .w-100 input {
    max-width: 100%;
    width: 100%;
  }

</style>



// WEBPACK FOOTER //
// src/apps/payment/paymentHistory.vue